import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Agent, AgentClient, AgentService, AgentServicesClient, NServices } from "src/app/web-api-client";
import { SuccessModalComponent } from "../../../../modals/success-modal/success-modal.component";
import { AgentServiceCreationComponent } from "./agentService-creation/agentService-creation.component";
import { AgentServiceEditComponent } from "./agentService-edit/agentService-edit.component";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";

@Component({
  selector: 'app-agent-edit',
  templateUrl: './agent-edit.component.html',
  styleUrls: ['./agent-edit.component.scss']
})
export class AgentEditComponent implements OnInit {

  public isLoaded = false;
  public editObject: Agent;
  public agentServices: AgentService[] = [];
  public selectedService: AgentService;
  public onClose = new Subject<boolean>();

  Form: FormGroup;

  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal, public modalService: NgbModal, public client: AgentClient,public agentServiceClient:AgentServicesClient) { }

  ngOnInit(): void {

    this.loadData();
  }


  // Assuming you already have a property for all the agent services
  public searchQuery: string = '';
  public filteredAgentServices: AgentService[] = [];

  filterAgentServices() {
    if (this.searchQuery) {
      this.filteredAgentServices = this.agentServices.filter(service =>
        service.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.service.serviceName.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.service.yri.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.agentCommission.toString().toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.bankDetails.iban.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.bankDetails.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.isActive.toString().toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    } else {
      this.filteredAgentServices = this.agentServices;
    }
  }


  public loadData() {
    this.agentServiceClient.getList(this.editObject.idAgent).subscribe(agents => {

      this.agentServices = agents;
      this.filteredAgentServices = agents;

      this.initializeForm();

      this.isLoaded = true;

    })
  }
  initializeForm() {
    this.Form = this.fb.group({
      agentName: [this.editObject.agentName, Validators.required],
      agentEIK: [this.editObject.agentEIK, Validators.required],
      defaultComission: [this.editObject.defaultComission, Validators.required],
      isActive: [this.editObject.isActive, Validators.required],
    });
  }

  onSubmit() {
    if (this.Form.valid) {


      this.editObject.agentName = this.Form.value.agentName;
      this.editObject.agentEIK = this.Form.value.agentEIK;
      this.editObject.defaultComission = this.Form.value.defaultComission;
      this.editObject.isActive = this.Form.value.isActive;



      this.client.update(this.editObject).subscribe((user) => {
        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

  getAccountDetails(agentService: AgentService) {
    if(!agentService.bankDetails)
      return "няма въведени банкови данни";

    return `${agentService.bankDetails.title} (${agentService.bankDetails.iban})`
  }



  public onCreation(): void {


    const modalRef = this.modalService.open(AgentServiceCreationComponent, { size: 'xl', centered: true,backdrop:'static' });
    modalRef.componentInstance.agentId = this.editObject.idAgent;
    modalRef.componentInstance.onClose.subscribe(r => {

      this.loadData();

    });
  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }
  public onDelete(): void {

    this.agentServiceClient.remove(this.selectedService.idAgentsService).subscribe(r => {
      this.modalService.open(SuccessModalComponent, {});
    });
  }

  public onEdit(): void {


    let modalRef = this.modalService.open(AgentServiceEditComponent, { size: 'xl', centered: true,backdrop:'static' });
    modalRef.componentInstance.editObject = this.selectedService;
    modalRef.componentInstance.onClose.subscribe(r => {

      this.loadData();
    });
  }

  public isSelected(service: AgentService) {

    if (!this.selectedService)
      return false;

    let result = this.selectedService.idAgentsService == service.idAgentsService;
    return result;
  }

  public onUserSelected(service: AgentService) {
    if (this.isSelected(service)) {
      this.selectedService = null;
    }
    else {

      this.selectedService = service;
    }

  }


}
